import { Component, OnInit, ViewChild } from '@angular/core';
import { SubmissionsService } from '../_services/submissions.service';
import { AddressType, SubmissionSteps } from '../../_common/_enum/module.enum';
import { Submission } from '../_models/submission';
import { API_URL } from 'src/app/_common/constants';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-submission-business-lookup',
  templateUrl: './submission-business-lookup.component.html',
  styleUrls: ['./submission-business-lookup.component.scss']
})
export class SubmissionBusinessLookupComponent implements OnInit {

  private referenceData; //Using it in HTML
  private submissionSteps = SubmissionSteps; //Using it in HTML
  private apiUrl = API_URL; //Using it in HTML
  private addressTypes = AddressType; //Using it in HTML

  private submissionBusinessLookup: Submission;
  private submissionData;
  private businessStateSelected: any;

  @ViewChild("businessLookupForm", {static: false}) businessLookupForm: NgForm;

  constructor(private submissionService: SubmissionsService) { }

  ngOnInit() {
    this.referenceData = this.submissionService.referenceData;
    this.submissionBusinessLookup = this.getSubmission();
    this.submissionData = this.submissionBusinessLookup.submissionData;
  }

  get addressTypeEnum(){
    return this.addressTypes;
  }

  getSubmission(){
    return this.submissionService.submission;
  }

  getAddress(_type){
    return this.submissionData.addresses.find(_address=> {return _address.addressType == _type});
  }

  updateStateVal(_selectedval) {
    this.businessStateSelected = _selectedval;
  }

}
